import ApiGenericServicesData from "service/ApiGenericServicesData";
import { codificarValorSeguro } from "util/codificarValorSeguro";

export default class CertificacionDeGoceDeSusDerechosPoliticos extends ApiGenericServicesData{
    constructor(){
        super("certificacionDeGoceDeSusDerechosPoliticos");
    }

    async openFile(fileName) {
        const fileNameSeguro = await codificarValorSeguro(fileName);
        return this.customGET("openFile/" + fileNameSeguro);
    }
}
